<h1 mat-dialog-title class="condensed">{{ data.title }}</h1>
<div mat-dialog-content>
    <p [innerHTML]="data.text"></p>
</div>
<div mat-dialog-actions class="d-flex flex-wrap">
    @if (data.cancel) {
        <button mat-button (click)="onNoClick()">{{ data.cancel }}</button>
    }
    <div class="spacer"></div>
    @if (data.confirm) {
        <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial color="primary">{{ data.confirm }}</button>
    }
</div>
